var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { Box, Button, Card, CardContent, Typography, Divider, IconButton, Dialog, DialogContent, DialogTitle, Stack, Grid, } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { utility } from '../../utils';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import DoneIcon from '@mui/icons-material/Done';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../UtilityComponents/ConfirmationAndInformationPoup';
import { useSelector } from 'react-redux';
var VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
var InsuranceConfig = function () {
    var _a = useState([]), pdfFiles = _a[0], setPdfFiles = _a[1];
    var _b = useState(false), previewOpen = _b[0], setPreviewOpen = _b[1];
    var _c = useState(null), previewFile = _c[0], setPreviewFile = _c[1];
    var _d = useState({ open: false, file: null }), deletePopup = _d[0], setDeletePopup = _d[1];
    var rolePermissions = useSelector(function (store) { var _a; return ((_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) || []; });
    var permission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:GLOBAL_SETTINGS:INSURANCE_POLICY'; });
    var canUpdate = (permission === null || permission === void 0 ? void 0 : permission.Update) === 1;
    var canDelete = (permission === null || permission === void 0 ? void 0 : permission.Delete) === 1;
    useEffect(function () {
        var fetchDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, responseData, files, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, api_service.get({
                                endPoint: api_urls.GET_INSURANCE_POLICY_DOC,
                                showLoader: true
                            })];
                    case 1:
                        response = _a.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            responseData = response.data.data;
                            if (Array.isArray(responseData)) {
                                files = responseData
                                    .filter(function (doc) { return doc.InsuranceFileName && doc.InsuranceFileUrl && doc.LanguageSelection; })
                                    .map(function (doc) { return ({
                                    name: doc.InsuranceFileName,
                                    url: doc.InsuranceFileUrl,
                                    size: 0,
                                    uploadDate: new Date(doc.CreatedTime).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }),
                                    documentId: doc.Id,
                                    language: doc.LanguageSelection,
                                }); });
                                setPdfFiles(files);
                            }
                            else {
                                setPdfFiles([]);
                            }
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error fetching document:', error_1);
                        utility.alert('Failed to fetch document. Please try again.', 'error');
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        fetchDocument();
    }, []);
    var validateFile = function (file) {
        if (file.type !== 'application/pdf') {
            utility.alert('Please upload a PDF file only', 'error');
            return false;
        }
        var maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            utility.alert('File size must be less than 10MB', 'error');
            return false;
        }
        return true;
    };
    var handleFileUpload = function (event, language) { return __awaiter(void 0, void 0, void 0, function () {
        var files, file, formData, response, responseData, newFile_1, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    files = event.target.files;
                    if (!(files && files.length > 0)) return [3, 4];
                    file = files[0];
                    if (!validateFile(file)) {
                        return [2];
                    }
                    formData = new FormData();
                    formData.append('File', file);
                    formData.append('LanguageSelection', language);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, api_service.post({
                            endPoint: api_urls.UPLOAD_INSURANCE_POLICY_DOC,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true
                        })];
                case 2:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        responseData = response.data.data;
                        newFile_1 = {
                            name: responseData.InsuranceFileName,
                            url: responseData.InsuranceFileUrl,
                            size: file.size,
                            uploadDate: new Date(responseData.CreatedTime).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            }),
                            documentId: responseData.Id,
                            language: language
                        };
                        setPdfFiles(function (prev) {
                            var filtered = prev.filter(function (f) { return f.language !== language; });
                            return __spreadArray(__spreadArray([], filtered, true), [newFile_1], false);
                        });
                        utility.alert('File uploaded successfully', 'info');
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to upload file', 'error');
                    }
                    return [3, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error('Error uploading file:', error_2);
                    utility.alert('Failed to upload file. Please try again.', 'error');
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handlePreview = function (file) {
        setPreviewFile(file);
        setPreviewOpen(true);
    };
    var handleClosePreview = function () {
        setPreviewOpen(false);
        setPreviewFile(null);
    };
    var formatFileSize = function (bytes) {
        if (bytes === 0)
            return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };
    var handleDelete = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(file === null || file === void 0 ? void 0 : file.documentId)) return [3, 2];
                    return [4, api_service.delete({
                            endPoint: "".concat(api_urls.DELETE_INSURANCE_POLICY_DOC, "?DocumentId=").concat(file.documentId),
                            showLoader: true
                        })];
                case 1:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        setPdfFiles(function (prev) { return prev.filter(function (f) { return f.documentId !== file.documentId; }); });
                        utility.alert('File deleted successfully', 'info');
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to delete file', 'error');
                    }
                    _b.label = 2;
                case 2: return [3, 4];
                case 3:
                    error_3 = _b.sent();
                    console.error('Error deleting file:', error_3);
                    utility.alert('Failed to delete file. Please try again.', 'error');
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var getFileByLanguage = function (lang) { return pdfFiles.find(function (f) { return f.language === lang; }); };
    return (React.createElement(Box, { sx: { p: 3 } },
        React.createElement(Card, { sx: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h5", gutterBottom: true }, "Insurance Policy Document"),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 } }, "PDF format only | Maximum size: 10MB | Accessible to all dealers"),
                React.createElement(Grid, { container: true, spacing: 2, mb: 2 }, [{ lang: 'en', label: 'English' }, { lang: 'fr', label: 'French' }].map(function (_a) {
                    var lang = _a.lang, label = _a.label;
                    var file = getFileByLanguage(lang);
                    return (React.createElement(Grid, { item: true, xs: 12, md: 6, lg: 4, key: lang },
                        React.createElement(Stack, { sx: {
                                bgcolor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                p: 2
                            } },
                            React.createElement(Stack, { direction: 'row', justifyContent: 'space-between' },
                                React.createElement(Typography, { variant: "h6", fontSize: 14 }, label),
                                file && (React.createElement(Stack, { direction: 'row', gap: 0.4, color: '#49a976' },
                                    React.createElement(DoneIcon, { sx: { fontSize: 18 } }),
                                    React.createElement(Typography, { variant: "h6", fontSize: 14 }, "Uploaded")))),
                            React.createElement(Stack, { mt: 1, p: 1, borderRadius: '6px', bgcolor: file ? '#f0fff4' : undefined, border: file ? undefined : '1px dashed rgba(0, 0, 0, 0.12)' },
                                React.createElement(Stack, { alignItems: 'center', pb: 1, alignSelf: 'start' }, file ? React.createElement(DescriptionOutlinedIcon, null) : React.createElement(FolderOpenOutlinedIcon, null)),
                                file ? (React.createElement(Box, null,
                                    React.createElement(Stack, { direction: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 2 },
                                        React.createElement(Box, { overflow: 'hidden' },
                                            React.createElement(Typography, { sx: {
                                                    fontSize: 12,
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden', pr: 1
                                                } }, file.name),
                                            React.createElement(Box, { sx: {
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', sm: 'row' },
                                                    gap: { xs: 0.5, sm: 0.5 },
                                                    pl: 0
                                                } },
                                                React.createElement(Typography, { fontSize: 10, color: "text.secondary" },
                                                    "Size: ",
                                                    file.size ? formatFileSize(file.size) : '2.3 MB'),
                                                React.createElement(Divider, { orientation: "vertical", flexItem: true, sx: { display: { xs: 'none', sm: 'block' } } }),
                                                React.createElement(Typography, { fontSize: 10, color: "text.secondary" },
                                                    "Uploaded: ",
                                                    file.uploadDate))),
                                        React.createElement(Box, { sx: { display: 'flex', gap: 0.5 } },
                                            React.createElement(IconButton, { edge: "end", "aria-label": "preview", onClick: function () { return handlePreview(file); }, size: "small", sx: { p: 0.5 } },
                                                React.createElement(VisibilityIcon, { fontSize: "small" })),
                                            canDelete && (React.createElement(IconButton, { edge: "end", "aria-label": "delete", onClick: function () { return setDeletePopup({ open: true, file: file }); }, size: "small", sx: { p: 0.5 } },
                                                React.createElement(DeleteIcon, { fontSize: "small" }))))))) : (canUpdate && (React.createElement(Button, { component: "label", variant: "contained", startIcon: React.createElement(CloudUploadIcon, null), sx: { py: '3.5px' } },
                                    "Upload PDF",
                                    React.createElement(VisuallyHiddenInput, { type: "file", accept: ".pdf", onChange: function (e) { return handleFileUpload(e, lang); } }))))))));
                })))),
        React.createElement(Dialog, { open: previewOpen, onClose: handleClosePreview, maxWidth: "md", fullWidth: true },
            React.createElement(DialogTitle, { sx: { m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, previewFile === null || previewFile === void 0 ? void 0 :
                previewFile.name,
                React.createElement(IconButton, { "aria-label": "close", onClick: handleClosePreview, sx: {
                        color: function (theme) { return theme.palette.grey[500]; },
                    } },
                    React.createElement(CloseIcon, null))),
            React.createElement(DialogContent, null, previewFile && (React.createElement("iframe", { src: previewFile.url, style: { width: '100%', height: '80vh' }, title: "PDF Preview" })))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Are you sure?", message: "Are you sure you want to delete this document?", acceptBtnText: "Yes", denyBtnText: "No", open: deletePopup.open, acceptCallBack: function () {
                if (deletePopup.file)
                    handleDelete(deletePopup.file);
                setDeletePopup({ open: false, file: null });
            }, denyCallBack: function () { return setDeletePopup({ open: false, file: null }); }, cancelCallBack: function () { return setDeletePopup({ open: false, file: null }); } })));
};
export default InsuranceConfig;
